import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FormGroup, Label } from "reactstrap";

const Switch = ({ id, labelTrue, value, onFilterChange, labelFalse }) => {
  const [trueChecked, setTrueChecked] = useState(value === "all"  ? true : value);
  const [falseChecked, setFalseChecked] = useState(value === "all" ? true : !value);
  const trueSelected = trueChecked ? "btn btn-sm btn-toggle active" : "btn btn-sm btn-toggle";
  const falseSelected = falseChecked ? "btn btn-sm btn-toggle active" : "btn btn-sm btn-toggle";
  useEffect(() => {
    if (!falseChecked && !trueChecked) {
      onFilterChange(null);
    } else if (trueChecked && falseChecked) {
      onFilterChange("all");
    } else {
      if (trueChecked) {
        onFilterChange(true);
      }
      if (falseChecked) {
        onFilterChange(false);
      }
    }
    // we got infinite loop if we add onFilterChange reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trueChecked, falseChecked]);
  return (
    <FormGroup className="boolean-filter-container">
      <Label className="boolean-filter-label" for={id}>
        {labelTrue}
      </Label>
      <button
        type="button"
        className={trueSelected}
        data-toggle="button"
        aria-pressed="true"
        autoComplete="off"
        onClick={() => setTrueChecked(!trueChecked)}
      >
        <div className="handle" />
      </button>
      <Label className="boolean-filter-label" for={id}>
        {labelFalse}
      </Label>
      <button
        type="button"
        className={falseSelected}
        data-toggle="button"
        aria-pressed="true"
        autoComplete="off"
        onClick={() => setFalseChecked(!falseChecked)}
      >
        <div className="handle" />
      </button>
    </FormGroup>
  );
};

Switch.propTypes = {
  id: PropTypes.string,
  labelTrue: PropTypes.string,
  labelFalse: PropTypes.string,
  onFilterChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

Switch.defaultProps = {
  id: "",
  labelTrue: "",
  labelFalse: "",
  value: "",
  onFilterChange: () => {}
};

export default Switch;
